import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { reviewService } from '@/api/services/reviewService'
import { useAuthStore } from '@/store/useAuthStore'

export function useTrainerReviews(p?: Parameters<typeof reviewService.trainerReviews>[0]) {
  const isSchoolAdmin = useAuthStore(s => String(s.user?.user_type ?? '').toUpperCase() === 'SCHOOL_ADMIN')
  return useQuery({ queryKey: ['reviews', 'trainer', p, isSchoolAdmin], queryFn: () => reviewService.trainerReviews(p, isSchoolAdmin), staleTime: 30_000 })
}

export function useStudentReviews(p?: Parameters<typeof reviewService.studentReviews>[0]) {
  const isSchoolAdmin = useAuthStore(s => String(s.user?.user_type ?? '').toUpperCase() === 'SCHOOL_ADMIN')
  return useQuery({ queryKey: ['reviews', 'student', p, isSchoolAdmin], queryFn: () => reviewService.studentReviews(p, isSchoolAdmin), staleTime: 30_000 })
}

export function useRemoveReview() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (id: number) => reviewService.delete(id), onSuccess: () => qc.invalidateQueries({ queryKey: ['reviews'] }) })
}

export function useFlagReview() {
  const qc = useQueryClient()
  return useMutation({ mutationFn: (data: Record<string, unknown>) => reviewService.update(data), onSuccess: () => qc.invalidateQueries({ queryKey: ['reviews'] }) })
}
